export default {"src":"/_next/static/media/rupee-icon.74b19853.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};